<template>
    <div class="body">
		<div style="width: 90%;margin: 0 auto;">
			<p style="margin: 0 auto; font-size: 20px;color: #000;padding-top: 7vh;">现在为你生成10月专属成长计划：💡</p>
			<ul style="background-color: rgba(171, 168, 168, 0.3);border-radius: 10px;">
                <li v-for="(course, index) in allCourses" :key="index" style="color: #fff;">{{ course }}</li>
            </ul>
		</div>	
        <div class="footer">
            <p style="width: 90%;margin: 0 auto;">点击“生成计划”，可建立富学宝典学习计划（富学宝典每10天更新一次）</p>
            <button class="confirm-btn" @click="confirmSubmit">生成计划</button>
      </div>
    </div>
</template>
  
<script>
export default {
    props: {
        ReportData: {
            type: Object,
            required: false
        },
        selectedMap: {
            type: Object,
            default: () => ({ A: [], B: [], C: [], D: [] })
        }
    },
    data() {
        return {
            // selectedCourses: []
        };
    },
    computed: {
        allCourses() {
            const map = this.selectedMap || { A: [], B: [], C: [], D: [] };
            return [
            ...(map.A || []),
            ...(map.B || []),
            ...(map.C || []),
            ...(map.D || [])
            ];
        }
    },
    methods:{
        confirmSubmit() {
            const payload = {
                selectedCourses: {
                    A: this.selectedMap.A,
                    B: this.selectedMap.B,
                    C: this.selectedMap.C,
                    D: this.selectedMap.D,
                },
            };
            const view= {
                studyPlan: JSON.stringify(payload)
            };
            this.$emit('submit', view);
        }
    }
}
</script>
  
<style scoped>
.body {
	background: 
        url("../../assets/25September/logo.png") right  top  no-repeat,
        url("../../assets/25September/bg.jpg")  no-repeat;
	background-size: 100% 100%,cover;
	width: 100%;
	height: 100vh;
}

ul{
    list-style-type: none;
    padding: 0;
    color: #000;
    margin: 0;
    /* text-align: center; */
}

li {
    align-items: center;
    /* margin-bottom: 1px;  */
}

li::before {
    content: '\2022'; /* 使用小圆点作为列表标记 */
    color: #000; /* 可根据需要调整小圆点的颜色 */
    font-size: 1.5em; /* 可调整小圆点的大小 */
    margin-right: 3px; /* 可调整小圆点与文字之间的间距 */
    margin: 0 auto;
}

.font1 {
    width: 96%;
    margin: 0 auto;
    /* text-align: center; */
    font-size: 20px;
    color: #528ce8;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.font2 { 
    width: 96%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #fff;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.font3 {
    font-size: 20px;
    font-weight: bold;
    color: #64892f;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.footer {
    text-align: center;
    padding-top: 20px;
}
  
.confirm-btn {
    background-color: #62c4e1;
    color: white;
    border: none;
    border-radius: 20px;
    padding: 5px 20px;
    font-size: 16px;
    cursor: pointer;
    margin-top: 20px;
}
  
.confirm-btn:disabled {
    background-color: #bbb;
    cursor: not-allowed;
}
@media screen and (min-width: 786px) {
  .body {
    background: 
                url("../../assets/25September/pcbg.jpg")  no-repeat;
    background-size:cover;
    width: 100%;
    height: 100vh;
  }
}
</style>